import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { logoutAction as logout } from "../../store/auth/userSlice";
import { useI18n } from "../../hooks/useI18n";
import api from "../../api";

export default function Logout() {

  const { t } = useI18n(['auth', 'common']);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleConfirm = async (confirm) => {
    if (confirm) {
      try {
        await api.post("/users/auth/logout/");
      } catch (error) {
        console.error("Errore durante la chiusura della sessione lato backend", error);
      } finally {
        dispatch(logout());
        if (typeof persistor !== "undefined") {
            await persistor.purge();
        }
      }
    } else {
      navigate(-1);
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="80vh"
      bgcolor="background.default"
      px={2}
    >
      <Paper
        sx={{ p: 4, borderRadius: 3, maxWidth: 400, width: "100%", textAlign: "center" }}
        elevation={3}
      >
        <LogoutIcon color="error" sx={{ fontSize: 48, mb: 2 }} />
        <Typography variant="h6" gutterBottom>
          {t('logout.title', { defaultValue: 'Logout' })}
        </Typography>
        <Typography variant="body1" mb={3}>
          {t('logout.message', { defaultValue: 'Sei sicuro di voler uscire?' })}
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="center">
          <Button
            variant="contained"
            color="error"
            startIcon={<LogoutIcon />}
            onClick={() => handleConfirm(true)}
          >
            {t('logout.confirm', { defaultValue: 'Sì. esci' })}
          </Button>
          <Button
            variant="outlined"
            onClick={() => handleConfirm(false)}
          >
            {t('buttons.cancel', { ns: 'common', defaultValue: 'Annulla' })}
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
